import { ButtonUniDriver } from '@wix/design-system/dist/testkit/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import ImportModalUniDriver from './ImportModal.uni.driver';

export function ImportButtonUniDriver(base: UniDriver, body: UniDriver) {
  const getButton = () => ButtonUniDriver(base, body);
  const importModal = ImportModalUniDriver(base, body);

  return {
    ...importModal,
    /** Clicks the button to open import modal */
    click: () => getButton().click(),
    /** Indicates whether import button exists in the table toolbar */
    exists: () => getButton().exists(),
  };
}

export default ImportButtonUniDriver;
